export const SIGNATORY_CAPACITY_OPTIONS = [
  { value: "Director", label: "Director" },
  { value: "Authorised signatory", label: "Authorised signatory" },
  { value: "PoA", label: "PoA" },
];

export function normalizeSignatoryCapacity(value) {
  const raw = String(value || "").trim();
  const lower = raw.toLowerCase();

  if (!lower) return "";
  if (lower === "director") return "Director";
  if (
    lower === "authorised signatory" ||
    lower === "authorized signatory"
  ) {
    return "Authorised signatory";
  }
  if (
    lower === "poa" ||
    lower === "power of attorney" ||
    lower === "power-of-attorney"
  ) {
    return "PoA";
  }

  return "";
}
